import { css } from '@emotion/css'
import { colors, fontWeight, spacing } from '@offerzen/pinata-shame'

const styles = {
  remotePolicyList: css({
    listStyle: 'none',
    padding: 0,
    margin: 0,
  }),

  remotePolicyItem: css({
    color: colors.oxfordBlue,
    fontWeight: fontWeight.semiBold,

    b: {
      fontWeight: fontWeight.semiBold,
    },

    '& + *': {
      marginTop: spacing.default,
    },
  }),

  badge: css({
    marginRight: spacing.small,
  }),
}

export default styles
